// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/DimensionDefinition.yaml
// Generated: 2026-05-31T18:49:04.286Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateDimensionDefinition, UpdateDimensionDefinition, DimensionDefinition } from '@/types/finance/DimensionDefinition';

/**
 * DimensionDefinition Service
 * CRUD operations for DimensionDefinition via the ABP API.
 */
export const dimensionDefinitionService = new EntityService<DimensionDefinition, CreateDimensionDefinition, UpdateDimensionDefinition>(
  '/api/finance/dimensiondefinition',
  'DimensionDefinition',
);
